'use client';

import { useContext, type MouseEvent, type ReactNode } from 'react';
import { WalletContext } from '@/shared/providers/wallet-context';

interface PaymentActionsProps {
  children: ReactNode;
  className: string;
}

export const PaymentActions = ({
  children,
  className,
}: PaymentActionsProps) => {
  const wallet = useContext(WalletContext);

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    const target = event.target as HTMLElement;
    if (target.closest('[data-footer-payment-partner]')) {
      wallet?.openWallet();
    }
  };

  return (
    <div className={className} onClick={handleClick}>
      {children}
    </div>
  );
};
